import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import FormField from "../../../../components/common/FormField";
import CustomButton from "../../../../components/common/button/CustomButton";
import {
  getStorageSettingsAction,
  updateStorageSettingsAction,
} from "../../../../store/reducers/storageSettingSlice";
import Notification from "../../../../components/common/notification/Notification";

const MAX_INVOICE_LEAD_TIME = 10;

const InvoiceLeadTime = () => {
  const dispatch = useDispatch();
  const { storageSettings } = useSelector((state: any) => state.storageSetting);
  const [invoiceLeadTime, setInvoiceLeadTime] = useState<number | "">(0);

  useEffect(() => {
    dispatch(getStorageSettingsAction());
  }, [dispatch]);

  useEffect(() => {
    if (storageSettings?.invoice_lead_time != null) {
      const savedValue = Number(storageSettings.invoice_lead_time);
      setInvoiceLeadTime(
        Number.isInteger(savedValue) && savedValue >= 0
          ? Math.min(savedValue, MAX_INVOICE_LEAD_TIME)
          : 0,
      );
    }
  }, [storageSettings]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value === "") {
      setInvoiceLeadTime("");
    } else if (/^\d+$/.test(value)) {
      setInvoiceLeadTime(
        Math.min(Number(value), MAX_INVOICE_LEAD_TIME),
      );
    }
  };

  const handleSubmit = () => {
    if (invoiceLeadTime === "" || invoiceLeadTime > MAX_INVOICE_LEAD_TIME) {
      return;
    }

    dispatch(
      updateStorageSettingsAction({
        id: storageSettings?.id,
        invoice_lead_time: invoiceLeadTime,
      }),
    );
  };

  return (
    <Box sx={{ bgcolor: "#fff", p: 2, border: "1px solid #d1cfcf" }}>
      <Notification />
      <Grid container spacing={2}>
        <FormField
          id="invoice_lead_time"
          label="Invoice Lead Time (Days Prior to Contract Date)"
          labelFontSize="20px"
          type="number"
          value={invoiceLeadTime}
          onChange={handleChange}
          InputProps={{
            sx: {
              height: "30px",
              
            },
          }}
          isRequired
          inSingleGridForm
          isNonMarginTop
        />
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          <CustomButton
            title="Submit"
            onClick={handleSubmit}
            disabled={invoiceLeadTime === ""}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InvoiceLeadTime;
